<div class="col-12 p1">
    @if (begining) {
    <span [innerHtml]="begining"></span>
    <span class="_dots">...</span>
    <span class="_extra"
          [innerHtml]="rest"></span>
    <input type="checkbox"
           id="btn" />
    <label class="p-l-1 link-1 underline"
           [class._hide-opened]="!readLess()"
           for="btn"
           [attr.data-read-more]="'more' | translate"
           [attr.data-read-less]="'close' | translate"></label>
    } @else {
    <span [innerHtml]="text"></span>
    }
</div>